import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { IProduct } from '@/api/types-client'

export const defaultProduct: IProduct = {
  clientId: 0,
  productId: 0,
  name: '',
  description: '',
  orderTypeId: 0,
  listPrice: 0,
  vendorFee: 0,
  broadcastLimit: 10,
  distanceLimit: 20,
  assignmentTimeout: 3,
  orderType: null,
  avmReportAddOn: 'None',
  reportTitleOverride: ''
}

export interface IProductsState {
  ProductList: IProduct[]
  ProductSelected: (IProduct | null)
}

@Module({ dynamic: true, store, name: 'Product' })
class Products extends VuexModule implements IProductsState {
  public ProductList: IProduct[] = []
  public ProductSelected: IProduct | null = null
  public ClientId = 0

  @Mutation
  private DEL_ALL_ITEMS() {
    this.ProductList = []
  }

  @Mutation
  private LOAD_ITEMS(productList: IProduct[]) {
    this.ProductList = productList
  }

  @Mutation
  private SET_SELECTED(item: IProduct | null) {
    this.ProductSelected = item
  }

  @Mutation
  private UPDATE_ITEM(item: IProduct) {
    for (let v of this.ProductList) {
      if (v.clientId === item.clientId) {
        v = Object.assign(v, item)
        break
      }
    }
  }

  @Mutation
  private SET_CLIENT(clientId: number) {
    this.ClientId = clientId
  }

  // GETTERS
  get cachedProducts() {
    return this.ProductList
  }

  @Action
  public createNewProduct(): IProduct {
    return defaultProduct
  }

  @Action
  public loadProducts(productList: IProduct[]) {
    this.DEL_ALL_ITEMS()
    this.LOAD_ITEMS(productList)
  }

  @Action
  public setSelectedProduct(product: IProduct) {
    this.SET_SELECTED(product)
  }

  @Action
  public setClient(clientId: number) {
    this.SET_CLIENT(clientId)
  }

  @Action
  public updateProduct(product: IProduct) {
    if (this.ProductSelected == null) return
    if (this.ProductSelected.clientId !== product.clientId) return
    this.SET_SELECTED(product)
    this.UPDATE_ITEM(product)
  }
}

export const ProductModule = getModule(Products)
